
import { defineComponent, reactive } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
    name: "my-nav",
    props: {
        menuList: {
            type: Array,
            default: () => [],
        },
    },
    setup(props: any) {
        let state = reactive({
            menuList: props.menuList,
        });
        let router = useRouter();
        let gotoRoute = (name: any) => {
            router.push({ name });
        };
        return {
            state,
            gotoRoute,
        };
    },
});
